import { Stack, Typography } from '@mui/material'
import shared from '@/components/Settings/settingsShared.module.scss'

/**
 * Section intro: short lead line (no separate section title).
 *
 * @param {{
 *   headingId?: string,
 *   lines: readonly [string, string] | string[],
 * }} props
 */
export default function SettingsSectionIntro({ headingId, lines }) {
  if (!lines?.[0]) return null

  const [lead] = lines

  return (
    <Stack className={shared.settingsSectionIntro}>
      <Typography id={headingId} component="p" className={shared.settingsSectionIntroLead}>
        {lead}
      </Typography>
    </Stack>
  )
}
